<template>
    <span class="loading-dots">
        <span>.</span>
        <span>.</span>
        <span>.</span>
    </span>
</template>


<style scoped>
    .loading-dots {
        display: flex;
        align-items: center;
    }

    .loading-dots span {
        margin-right: 5px;
        animation: blink 1.4s infinite both;
    }

    @keyframes blink {
        0% { opacity: 0; }
        50% { opacity: 1; }
        100% { opacity: 0; }
    }
</style>